import { React , useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';

export default function ImportStatus(props) {
    const [ message, setMessage ] =
        useState(null);
    const [ client, setClient ] = 
        useState(null);

    const subscribeTopic = `${props.uuid}/import`;

    function updateMessage(topic, msg) {
        let msgStr = msg.toString();
        let msgObj = JSON.parse(msgStr);
        setMessage(msgObj);
    }

    useEffect(() => {
        if (props.initialStatus !== null) {
            setMessage(props.initialStatus);
        }
        if (props.client === null) {
            
            const MQTT = require('mqtt');
            let hostWithAuth = `${props.mqttClientCreds.basic_user}:${props.mqttClientCreds.basic_password}@${props.mqttClientCreds.host}`;
            let mqttOptions = {
                wsOptions: {
                    hostname: hostWithAuth,
                    port: props.mqttClientCreds.port,
                    path: '/'
                },
                servers: [{ host: hostWithAuth, port: props.mqttClientCreds.port }],
                protocolId: 'MQTT',
                protocolVersion: 5,
                protocol: 'wss',
                reconnectPeriod: 5000,
                clientID: 'mqttjs_' + Math.random().toString(16).substring(2, 10)
            };
            let cli = MQTT.connect(mqttOptions);
            setClient(cli);
            try {
            cli.on('connect', function() {
                // console.log(`ImportStatus() connected to ${props.mqttClientCreds.host}`);
                // console.log(`ImportStatus() subscribing to ${subscribeTopic}`);
                cli.subscribe(subscribeTopic);
            });
            cli.on('message', updateMessage)
            } catch(e) {
                console.log(JSON.stringify(e));
            }
            cli.on('error', (err) => {
                console.log('MQTT Client Error');
                console.log(err);
            })
            props.setClient(cli);
            /* return( () => {
                console.log(`ImportStatus() disconnecting from ${props.mqttClientCreds.host}`);
                cli.end();
            }); */
        }
    }, [props.client, props.initialStatus])

    if (message != null) {
    return(<Alert variant={message.variant}>
        <center>{message.message}</center>
    </Alert>)
    }
    return null;
}